// hooks/usePWAJumpIframe.ts
import { isInPWA, isInAndroidApp } from '@/env' // 确保路径正确
import { useUserInfo } from '@/store'
import { CUSTOM_PROTOCOL } from '@/consts'
import { getAuthStr } from '@/utils'
// import { saveUserNameAndPassword } from '@/utils'

export const iframeUrl = ref<any>(null)

const postData = async (url = '') => {
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*', // 注意跨域问题，可能需要调整
      'Content-Type': 'application/json',
    },
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return await response.json()
}

export const checkPWAAndPreventionJump = async () => {
    if (iframeUrl.value) return

    if (!isInPWA && !isInAndroidApp) {
      return
    }

    const currentUrl = new URL(window.location.href)
    const params = new URLSearchParams(currentUrl.search)
    const omit = [
      'preventionJump',
      'currentDomain',
      'tid',
      'pwaredirect',
      'info',
    ]
    const newUrlParams = Array.from(params.entries())
      .filter(([key]) => !omit.includes(key))
      .map(([key, value]) => `${key}=${value}`)
      .join('&')

    if (currentUrl.searchParams.get('preventionJump') !== 'true') {
      console.log('preventionJump 参数不是 true')
      return
    }

    const currentDomain = currentUrl.searchParams.get('currentDomain')

    // 获取iframe跳转的域名  如果没有就使用链接上的域名
    const iframeJumpDomain: any = JSON.parse(
      localStorage.getItem('iframeJumpDomain') as string,
    ) || [currentDomain]
    const getRandomElement = (array: string[]) => {
      return array[Math.floor(Math.random() * array.length)]
    }
    const jumpDomain = getRandomElement(iframeJumpDomain)

    // console.log('检测是否在 pwa 应用打开的项目``22222222```````', jumpDomain)
    let p = 'home'
    const page = params.get('pwaredirect')
    if (page) {
      const s = decodeURIComponent(page).replace(CUSTOM_PROTOCOL + '://', '')
      if (s) p = s.replace(/^\/+/, '')
    }
    let infoStr = ''
    if (getAuthStr(useUserInfo().userInfo) || params.get('info')) {
      infoStr = getAuthStr(useUserInfo().userInfo) || 'info=' + params.get('info')
    }
    if (infoStr === "info=null") {
      infoStr = ''
    }


    // // 这里，如果是从params里面取到的，就加一个标识，需要刷新token
    // // 否则直接使用（说明已经刷过了）
    // let infoStr = ''
    // if (getAuthStr(useUserInfo().userInfo)) {
    //   console.log("从UserInfo里取的，不需要刷新token")
    //   infoStr = getAuthStr(useUserInfo().userInfo) + '&needRefreshToken=0'
    // }
    // if (infoStr === '' && params.get('info')) {
    //   console.log("从params里取的，需要刷新token")
    //   infoStr = 'info=' + params.get('info') + '&needRefreshToken=1'
    // }
    // if (infoStr === "info=null") {
    //   infoStr = ''
    // }

    const newUrl = `https://${jumpDomain}/${p}${p.includes('?') ? '&' : '?'}${newUrlParams}${infoStr ? '&' + infoStr : ''}`

    iframeUrl.value = newUrl
    const result = await postData(
      `https://${currentDomain}/api/carbon-misc/public/domain/list?type=MainDomain`,
    ).catch(() => ({ data: [] }))

    if (result.data?.length) {
      const randomDomain = result.data
      localStorage.setItem('iframeJumpDomain', JSON.stringify(randomDomain))
    }
  }

  // checkPWAAndPreventionJump()
  // 测试

//apk防封进入后注册登录状态
window.setAPKLoginSession = (userInfo: any) => {
  const binaryString = urlsafeBase64Decode(userInfo)
  if (binaryString) {
    const decodedUserInfo = JSON.parse(utf8Decode(binaryString) as string)
    useUserInfo().login(decodedUserInfo, decodedUserInfo.token)
    console.log('setAPKLoginSession----Leo 测试', decodedUserInfo)
  }
}

function urlsafeBase64Decode(encodedString) {
  // 将 URL 安全的字符替换回标准 Base64 的字符
  const base64String = encodedString.replace(/-/g, '+').replace(/_/g, '/')
  try {
    return atob(base64String)
  } catch (e) {
    console.error('Base64 decode error:', e)
    return null
  }
}

function utf8Decode(binaryString) {
  try {
    // 使用 TextDecoder 将二进制字符串解码为 UTF-8 字符串
    return new TextDecoder('utf-8').decode(
      new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0))),
    )
  } catch (e) {
    console.error('UTF-8 decode error:', e)
    return null
  }
}
